export default __webpack_public_path__ + "static/media/clearbulb.5e43d4a3.jpeg";